class DrawerSubmenu extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector(':scope > .menu-drawer__menu-row > .menu-drawer__submenu-toggle');
    this.panel = this.querySelector(':scope > .menu-drawer__inline-submenu');
    this.triggers = this.querySelectorAll(
      ':scope > .menu-drawer__menu-row > .menu-drawer__submenu-toggle, :scope > .menu-drawer__menu-row > .menu-drawer__submenu-trigger'
    );

    if (!this.button || !this.panel) return;

    this.handleClick = () => this.setExpanded(!this.hasAttribute('open'));
    this.triggers.forEach((trigger) => trigger.addEventListener('click', this.handleClick));
  }

  disconnectedCallback() {
    this.triggers?.forEach((trigger) => trigger.removeEventListener('click', this.handleClick));
  }

  setExpanded(expanded) {
    this.toggleAttribute('open', expanded);
    this.triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', String(expanded)));
    this.panel.hidden = !expanded;

    const labelText = expanded ? this.button.dataset.collapseLabel : this.button.dataset.expandLabel;
    const label = this.button.querySelector('.menu-drawer__toggle-label');
    this.button.setAttribute('aria-label', labelText);
    if (label) label.textContent = labelText;

    if (!expanded) {
      this.querySelectorAll(':scope drawer-submenu[open]').forEach((submenu) => submenu.collapse());
    }
  }

  collapse() {
    this.setExpanded(false);
  }
}

if (!customElements.get('drawer-submenu')) {
  customElements.define('drawer-submenu', DrawerSubmenu);
}
